<template>
  <div v-if="subAccountInfo" class="p-sub-account-detail">
    <div class="p-sub-account-detail-form">
      <plv-form
        ref="form"
        :model="form"
        :rules="rules"
        form-width="600px"
        label-width="110px"
      >
        <plv-form-item
          label="分账号邮箱"
          label-height="16px"
        >
          <div class="p-sub-account-detail-item">{{ subAccountInfo.email }}</div>
        </plv-form-item>
        <plv-form-item
          label="密码"
          label-height="16px"
        >
          <div class="p-sub-account-detail-item">
            <span>******</span>
            <span class="p-link-btn" @click="handleResetPswModel">重置密码</span>
          </div>
        </plv-form-item>
        <plv-form-item
          label="联系人"
          props="contacts"
        >
          <plv-input
            v-model.trim="form.contacts"
            size="medium"
            placeholder="请输入联系人姓名"
            :en-length="1"
            :maxlength="50"
          />
        </plv-form-item>
        <plv-form-item
          prop="phone"
          label="手机号码"
        >
          <plv-input
            v-model="form.phone"
            size="medium"
            placeholder="请输入联系人手机号码"
          />
        </plv-form-item>
        <plv-form-item
          prop="memo"
          label="备注"
        >
          <plv-input
            v-model.trim="form.memo"
            size="medium"
            placeholder="请输入备注"
            :en-length="1"
            :maxlength="50"
          />
        </plv-form-item>
        <plv-form-item
          prop="balance"
          label="金额"
          :tips-text="isSubmiting ? '' : isResourceLimit ? $_getBalanceTip(form.balance) : '请输入分配金额，无延迟和研讨会使用均依赖于金额'"
        >
          <plv-input-number
            v-model="form.balance"
            size="medium"
            placeholder="请输入金额"
            :en-length="1"
            :max="100000000"
          />
        </plv-form-item>
        <plv-form-item label="账号到期时间" label-height="40px">
          <plv-radio-group v-model="form.expireType">
            <plv-radio value="group">跟随主账号</plv-radio>
            <plv-radio value="custom">
              自定义日期
            </plv-radio>
            <plv-date-picker
              v-model="form.expireDate"
              value-format="timestamp"
              disabled-before-now
              :disabled-date="getDisabledDate"
            />
          </plv-radio-group>
        </plv-form-item>
        <plv-form-item>
          <plv-button @click="handleSubmit">保存</plv-button>
        </plv-form-item>
      </plv-form>
    </div>
    <reset-psw-modal :visible.sync="resetPswVisible" @resetPassword="handleResetPassword" />
  </div>
</template>

<script>
import { defaultFormRules } from '@/utils/type';
import { sleep } from '@/utils/utils';
import accountInfoMixin from '@/mixins/accountInfo';
import ResetPswModal from '@component/resetPswModal/resetPswModal';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    ResetPswModal
  },
  mixins: [accountInfoMixin],
  data() {
    return {
      form: {
        unionId: '',
        contacts: '',
        phone: '',
        memo: '',
        balance: 0,
        expireType: '',
        expireDate: ''
      },
      resetPswVisible: false,
      isSubmiting: false,
      rules: {
        ...defaultFormRules,
        phone: [
          { type: 'string', message: '请输入联系人手机号码', required: true },
          { pattern: /^\d+$/, message: '手机号格式错误' },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.account.accountInfo
    }),
    ...mapGetters({
      subAccountInfo: 'account/subAccountInfo'
    }),
    currentId() {
      return this.$route.params.id;
    },
  },
  watch: {
    subAccountInfo: {
      handler(value) {
        this.form.phone = value.phone ?? '';
        this.form.memo = value.memo ?? '';
        this.form.balance = value.balance ?? 0;
        this.form.unionId = value.unionId;
        this.form.contacts = value.contacts;
        this.form.expireType = value.expireType;
        this.form.expireDate = value.expireDate;
      },
      immediate: true,
    },
    'form.expireType'(value) {
      if (value === 'group') {
        this.form.expireDate = '';
      }
      console.info(value);
    }
  },
  mounted() {
    this.$store.dispatch('account/getOverViewInfo');
  },
  methods: {
    getDisabledDate(date) {
      // 不得高于帐号的过期时间
      const liveEndDate = this.accountInfo.liveEndDate || 0;
      const vodEndDate = this.accountInfo.vodEndDate || 0;
      const amountEndDate = this.accountInfo.amountEndDate || 0;
      const endDate = Math.max(liveEndDate, vodEndDate, amountEndDate);
      if (endDate) {
        return date.getTime() > endDate;
      }
      return false;
    },
    async handleSubmit() {
      try {
        this.$emit('loading');
        this.isSubmiting = true;
        await this.$refs.form.validate();
        await this.$store.dispatch('account/updateSubAccountInfo', this.form);
        const updatedInfo = Object.assign(this.subAccountInfo, this.form);
        this.$store.commit('account/setSubAccountInfo', updatedInfo);
        // 后端重新设置有延迟
        await sleep(2 * 1000);
        await this.$store.dispatch('account/getOverViewInfo');
        this.$toast.success('保存成功');
      } finally {
        this.isSubmiting = false;
        this.$emit('cancelLoading');
      }
    },
    handleResetPswModel() {
      this.resetPswVisible = true;
    },
    async handleResetPassword(form) {
      this.form.password = form.password;
      try {
        await this.$store.dispatch('account/updateSubAccountInfo', this.form);
        this.$toast.success('修改成功');
      } catch {}
      this.resetPswVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-sub-account-detail {
  .p-link-btn {
    margin-left: 5px;
    color: #2196f3;
    cursor: pointer;
    font-size: 14px;
    &:active {
      opacity: .7;
    }
  }
  .plv-date-picker {
    margin-left: 10px !important;
  }
  .plv-radio-group {
    align-items: center;
  }
}
</style>
